/* eslint-disable react/no-array-index-key */
import React from 'react';
import ReactPDF from '@react-pdf/renderer';
import { htmlToText } from 'html-to-text';
import { format } from 'date-fns';
import { styles } from './style';
import { ICompany, IReceipt, IReceiptDetail } from '../../../types/types';
import { numberToWords } from '../../../utils/format';

export default function ReceiptCanvas({
  receipt,
  company,
  receiptDetails,
}: {
  receipt: IReceipt;
  company: ICompany;
  receiptDetails: IReceiptDetail[];
}) {
  const parsedDesc = receipt?.description ? htmlToText(receipt.description) : '';
  const amount = new Intl.NumberFormat('id-ID').format(receipt?.amount ?? 0);

  return (
    <ReactPDF.Document>
      <ReactPDF.Page size="A4" style={styles.page}>
        <ReactPDF.View style={styles.header}>
          <ReactPDF.View style={styles.logoContainer}>
            {/* Replace with actual logo URL */}
            {company?.logo ? <ReactPDF.Image src={company?.logo} style={styles.logo} /> : <ReactPDF.View />}
          </ReactPDF.View>
          <ReactPDF.View
            style={[
              styles.companyInfo,
              {
                fontSize: 8,
              },
            ]}
          >
            <ReactPDF.Text style={styles.companyName}>{company?.name}</ReactPDF.Text>
            <ReactPDF.Text style={styles.companyAddress}>{company?.address_line_1}</ReactPDF.Text>
            <ReactPDF.Text style={styles.companyAddress}>
              {company?.address_line_2 ? `${company?.address_line_2} ` : ''}
              {company?.city}
            </ReactPDF.Text>
            <ReactPDF.Text style={styles.companyAddress}>
              {company?.state ? `${company?.state}, ` : ''}
              {company?.zip_code}
            </ReactPDF.Text>
            <ReactPDF.Text style={styles.companyAddress}>{company?.country}</ReactPDF.Text>
            <ReactPDF.Text style={styles.companyAddress}>
              {company?.phone ? `Phone: ${company?.phone}` : ''}
            </ReactPDF.Text>
            <ReactPDF.Text style={styles.companyAddress}>
              {company?.email ? `Email: ${company?.email}` : ''}
            </ReactPDF.Text>
          </ReactPDF.View>
          <ReactPDF.View>
            <ReactPDF.Text style={styles.receiptTitle}>RECEIPT</ReactPDF.Text>
            <ReactPDF.View
              style={[
                styles.horizontalContainer,
                {
                  fontSize: 8,
                },
              ]}
            >
              <ReactPDF.View style={styles.verticalContainer}>
                <ReactPDF.Text>Payment No.</ReactPDF.Text>
                <ReactPDF.Text>Invoice No.</ReactPDF.Text>
              </ReactPDF.View>
              <ReactPDF.View style={[styles.verticalContainer, { alignItems: 'flex-end' }]}>
                <ReactPDF.Text>{receipt?.receipt_number}</ReactPDF.Text>
                <ReactPDF.View style={styles.invoiceNum}>
                  {receiptDetails?.map((detail, index) => (
                    <ReactPDF.Text key={index}>{detail.invoice?.invoice_number}</ReactPDF.Text>
                  ))}
                </ReactPDF.View>
              </ReactPDF.View>
            </ReactPDF.View>
          </ReactPDF.View>
        </ReactPDF.View>

        <ReactPDF.View style={styles.row}>
          <ReactPDF.Text style={styles.label}>Received From</ReactPDF.Text>
          <ReactPDF.Text style={styles.value}>{receipt?.partner?.name}</ReactPDF.Text>
        </ReactPDF.View>

        <ReactPDF.View style={styles.row}>
          <ReactPDF.Text style={styles.label}>Amount of money</ReactPDF.Text>
          <ReactPDF.Text style={[styles.amountValue, styles.flex1]}>
            {numberToWords(receipt?.amount ?? 0)}
          </ReactPDF.Text>
        </ReactPDF.View>

        <ReactPDF.View style={styles.row}>
          <ReactPDF.Text style={styles.label}>For Payment</ReactPDF.Text>
          <ReactPDF.Text style={styles.value}>{parsedDesc}</ReactPDF.Text>
        </ReactPDF.View>

        <ReactPDF.View style={[styles.row, { marginTop: 4 }]} />

        <ReactPDF.View style={styles.rowFooter}>
          <ReactPDF.View
            style={[
              styles.amountRow,
              {
                fontSize: 12,
              },
            ]}
          >
            <ReactPDF.Text style={styles.amountLabel}>Amount Rp</ReactPDF.Text>
            <ReactPDF.Text style={styles.amountValue}>{amount}</ReactPDF.Text>
          </ReactPDF.View>

          <ReactPDF.View style={styles.footer}>
            <ReactPDF.View
              style={[
                styles.contentCenter,
                {
                  fontSize: 11,
                },
              ]}
            >
              <ReactPDF.Text style={[styles.footerText, styles.marginBottom]}>
                {receipt?.date ? format(receipt.date, 'LLL dd, y') : 'N/A'}
              </ReactPDF.Text>
              <ReactPDF.Text style={[styles.footerText, styles.textBold]}>{company?.name}</ReactPDF.Text>
              {company?.signature ? <ReactPDF.Image src={company?.signature} style={styles.logo} /> : <ReactPDF.View />}
            </ReactPDF.View>
          </ReactPDF.View>
        </ReactPDF.View>
      </ReactPDF.Page>
    </ReactPDF.Document>
  );
}
